import {
    MarketStatsStyles
} from "../../../common/ts/components/charts/MarketStatsChart";
import {SerpMarketStatsChart} from "../../../common/ts/components/charts/SerpMarketStatsChart";

import "../../../common/ts/webcomponents/option/option";
import "../../../common/ts/webcomponents/dropdown/dropdown";
import "../../../common/ts/webcomponents/monoselect/monoselect";
(window as any).initTopAds = (isMobile:boolean) => {
    initMarketStats(isMobile);
    initDropdowns();
}

function initDropdowns() {
    const ptSelect = document.getElementById("property-type-select") as HTMLSelectElement;
    const otSelect = document.getElementById("operation-type-select") as HTMLSelectElement;
    ptSelect?.addEventListener("change", () => {
        const ptSelected = ptSelect.value;
        const otSelected = otSelect.value;
        const url = window.location.href.split("?")[0]
        const queryParams = "?" + new URLSearchParams({pt: ptSelected, ot: otSelected}).toString()
        window.location.href = url + queryParams
    });

    otSelect?.addEventListener("change", () => {
        const ptSelected = ptSelect.value;
        const otSelected = otSelect.value;
        const url = window.location.href.split("?")[0]
        const queryParams = "?" + new URLSearchParams({pt: ptSelected, ot: otSelected}).toString()
        window.location.href = url + queryParams
    });
}

function initMarketStats(isMobile: boolean) {
    const marketStatsStyles: MarketStatsStyles = {
        lineColor: '#FF5050',
        fillColor: '#FF50500D',
        pointColor: '#FFFFFF',
        pointHoverColor: '#FF5050',
        scalesLabelColor: '#4A4A4A',
        pointRadius: isMobile ? 5 : 8,
        tickPadding: isMobile ? 0 : 10,
        tooltipTitleFontSize: isMobile ? 10 : 14,
        tooltipBodyFontSize: isMobile ? 12 : 16,
    };
    new SerpMarketStatsChart().init(marketStatsStyles, '.js-market-stats-chart');
}
